module.exports = __webpack_public_path__ + "ccf24a955c4521fad9d46a8a5096987c.svg";